// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

//TEMP, remove once the DEBUG navigate is removed
import { Router } from '@angular/router';
//TEMP

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';
import { CASValidate } from '../../shared/library/casValidate';

//Token
import { authToken } from '../../shared/authToken';

//Classes
import { FormAction } from "../../shared/classes/formAction";


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// TaggingManagementComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.tag-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.tag-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.tag-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.tag-legend-item-div{margin:0 16px 0 2px}.tag-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.tag-control-lbl{margin-right:4px}.tag-filter-radio{padding-left:10px;display:flex;align-items:center}.tag-main-control-break{flex-basis:100%;height:0}.tag-control-div{display:flex;align-items:center;margin:20px 0 10px 0;padding-left:20px;font-size:12px}.tag-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:25px 15px 10px 25px;margin:0 10px;max-width:900px}.tag-ui-flex-field-div{margin:0 0 0 0;display:flex;align-items:center}.tag-ui-flex-field-lbl{white-space:nowrap;flex-wrap:nowrap}.tag-upper-div{flex-grow:0}.tag-lower-div{position:relative;flex-grow:1;border-top:solid 1px #ccc}.tag-ui-popup-edit{width:625px;max-width:625px;overflow:hidden}.tag-ui-popup-export{width:500px;max-width:500px}.tag-ui-dates-block{display:flex}.tag-cssClasses_Grid{border-top:solid 1px #bbb}.tag-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.tag-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.tag-cssClasses_EditableCell_complete{border:solid 1px green !important}.tag-cssClasses_Grid_MS{border-bottom:none !important}.tag-cssClasses_Body_MS{border:solid 1px #b8b8b8;border-radius:2px;background-color:#f0f0f0}.tag-cssClasses_Cell_MS{padding:0 2px !important}.tag-list{width:75px;height:80px;border:solid 1px #b8b8b8;padding:2px;overflow-y:auto;background-color:#f0f0f0}.tag-list-button{margin:0 5px;font-size:18px}'],
    template : '<!--Content Div-->\n<div class="tag-main-content-div" data-test-id="content_tagging_view">\n\n    <!--=========================================================================================-->\n    <!--Upper Content Area-->\n    <!--=========================================================================================-->\n    <div class="tag-upper-div">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Title -->\n        <!-- ---------------------------------------------------- -->\n        <h2 tabindex="-1" class="cpd-title-div">CPDES Tagging Management</h2>\n\n        <!--Data Filters-->\n        <div class="tag-control-div" role="radiogroup" aria-labelledby="divRadioLabel">\n\n            <!--CATEGORY FILTER-->\n            <div>\n                <label for="selCategoryFilter" aria-label="Category Filter" title="Category Filter ">Filter By Category:&nbsp;</label>\n                <select id="selCategoryFilter" [(ngModel)]="_selectedCategoryFilter" (change)="categoryFilterChanged($event)">\n                    <option *ngFor="let category of _categoryFilters;" [ngValue]="category">{{category.tag_category_name}}</option>\n                </select>\n            </div>\n\n        </div>\n    </div>\n\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Grid Div -->\n    <!-- ---------------------------------------------------- -->\n    <ng-container>\n        <div class="tag-main-grid-div">\n            <cas-grid #tagManagementGrid\n                      summary="Tags"\n                      [settings]="_tagManagementGridSettings"\n                      (onRowSelectionChanged)="gridRowSelected()"\n                      (onRefreshClicked)="gridRefreshClicked()"\n                      (onSearch)="onGridSearch($event)">\n            </cas-grid>\n        </div>\n    </ng-container>\n\n\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="tagging_management_page_popups"></div>\n\n    <!--========================================-->\n    <!-- Tagging Edit Popup -->\n    <!--========================================-->\n    <modal #popEditTag\n           title={{_popupTagTitle}}\n           containerId="tagging_management_page_popups"\n           label="popEditTag"\n           customClass="tag-ui-popup-edit">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_edit_tag"></section>\n\n        <!-- body -->\n        <section>\n\n            <div id="popupEditTagFields" class="cpd-ui-row" data-test-id="section_edit_tag">\n\n                <div class="cpd-ui-cell" style="flex-grow: 1;">\n\n                    <div class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Tag Details</h3></div>\n\n                    <!-- ---------------------------------------------------- -->\n                    <!--tag_name-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div">\n                        <label for="tag_name" style="width:150px;">Tag Name<span class="cpd-required">*</span></label>\n                        <input id="tag_name"\n                               name="tag_name"\n                               type="text"\n                               aria-required="true"\n                               [attr.data-cval-msg-element-id]="\'tag_name_vmsg\'"\n                               [attr.data-cval-fld-name]="\'Tag Name\'"\n                               [attr.data-cval-required]="true"\n                               style="flex-grow:1;"\n                               class="cval"\n                               (input)="_formChanged(\'popEditTag_body\');"\n                               maxlength="50"\n                               [ngModel]="_popupTag?.tag.tag_name" (ngModelChange)="_popupTag.tag.tag_name=$event; _formChanged(\'popEditTag_body\')" />\n                    </div>\n                    <!--validation message-->\n                    <div id="tag_name_vmsg" class="cval-validation-message" style="padding-left:160px;"></div>\n                    <div id="tagInUseMessage" *ngIf="_popupTag?.tag.tag_name && _tagsInUse.includes(_popupTag?.tag.tag_name)" class="cval-validation-message" style="padding-left:160px;">Tag Name already in use</div>\n\n                    <!-- ---------------------------------------------------- -->\n                    <!--tag_description-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div">\n                        <label for="tag_description" style="width:150px; align-self:flex-start;">Tag Description</label>\n                        <textarea id="tag_description"\n                                  name="tag_description"\n                                  rows="5"\n                                  type="text"\n                                  [attr.data-cval-msg-element-id]="\'tag_description_vmsg\'"\n                                  [attr.data-cval-fld-name]="\'Tag Description\'"\n                                  [attr.data-cval-required]="false"\n                                  style="flex-grow:1;"\n                                  class="cval"\n                                  (input)="_formChanged(\'popEditTag_body\');"\n                                  maxlength="500"\n                                  [ngModel]="_popupTag?.tag.tag_description" (ngModelChange)="_popupTag.tag.tag_description=$event; _formChanged(\'popEditTag_body\')">\n                        </textarea>\n                    </div>\n\n\n                    <!-- ---------------------------------------------------- -->\n                    <!--category-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div">\n                        <label for="tag_category" style="width:150px; align-self:flex-start;">Tag Category<span class="cpd-required">*</span></label>\n                        <select id="tag_category"\n                                aria-required="true"\n                                [(ngModel)]="_selectedPopupCategory"\n                                (ngModelChange)="_selectedPopupCategory=$event; _formChanged(\'popEditTag_body\')"\n                                [attr.data-cval-msg-element-id]="\'category_vmsg\'"\n                                [attr.data-cval-fld-name]="\'Tag Category\'"\n                                [attr.data-cval-dropdown-selected]="true"\n                                class="cval">\n                            <option *ngFor="let category of _popupCategories;" [ngValue]="category">{{category.tag_category_name}}</option>\n                        </select>\n                        <!--validation message-->\n                        <div id="category_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n\n                    <!-- ---------------------------------------------------- -->\n                    <!--start_date-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div">\n                        <label for="start_date_selector" style="width:150px;">Start Date<span class="cpd-required">*</span></label>\n                        <input type="date"\n                               [min]="_today"\n                               placeholder="m/d/yyyy"\n                               id="start_date_selector"\n                               name="start_date_selector"\n                               aria-required="true"\n                               data-cval-msg-element-id="start_date_vmsg"\n                               [attr.data-cval-fld-name]="\'Start Date\'"\n                               [attr.data-cval-required]="true"\n                               [attr.data-cval-date]="true"\n                               style="width:140px;"\n                               aria-label="Start date (format m/d/yyyy)"\n                               class="form-control cval"\n                               [ngModel]="_popupTag?.tag.start_date"\n                               (ngModelChange)="_popupTag.tag.start_date=$event; _formChanged(\'popEditTag_body\')" />\n                        <!--validation message-->\n                        <div id="start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    </div>\n\n                </div>\n\n            </div>\n\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" accesskey="s" class="btn btn-primary" (click)="saveTag()"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n    <!--========================================-->\n    <!-- Tagging End Popup -->\n    <!--========================================-->\n    <modal #popEndTag\n           title="End Tag"\n           containerId="tagging_management_page_popups"\n           label="popEndTag"\n           customClass="tag-ui-popup-edit">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_edit_tag"></section>\n\n        <!-- body -->\n        <section>\n            <div style="margin-bottom:5px;">\n                <span style="font-weight:bold">Tag: </span><span>{{_selectedRow?.tag_name}}</span>\n            </div>\n            <div class="cpd-ui-row">\n                <div class="cpd-ui-cell" style="width:100%">\n                    <div class="cpd-ui-field-div">\n                        This action will permanently end this tag. If you wish to continue click the Save button.\n                    </div>\n                </div>\n            </div>\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" accesskey="s" data-dismiss="modal" (click)="endTag()"><u>S</u>ave</button>\n        </footer>\n\n    </modal>\n\n</div>\n',
    providers: [],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})

export class TaggingManagementComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('tagManagementGrid') tagManagementGrid;
    @ViewChild('popEditTag') popEditTag;
    @ViewChild('popEndTag') popEndTag;

    //Class wide member reference for the growls control
    growlBox = null;

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'taggingManagement.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'taggingmanagement'; //Just a shortcut (also helpful for cut & paste)
    _pageLoading = true;
    _categoryFilter = null;
    _valid = true;

    //Popup
    _popupMode = "add"; //[add, edit]
    _popupDirty = false;
    _popupValid = true;
    _popupTagTitle = "Add Tag";
    _popupCategories = [];
    _selectedPopupCategory = this._popupCategories[0];

    //Data
    _selectedRow = null;
    _selectedTagId = null;
    _selectedCategory = "";
    _categoryFilters = [];
    _selectedCategoryFilter = this._categoryFilters[0];
    _tagsInUse = [];

    _popupTag = {

        tag: {
            tag_id: null,
            tag_name: "",
            tag_description: "",
            start_date: "",
            tag_category: []
        }
    }

    //Tagging Management Grid
    _tagManagementGridSettings = {
        hideClearSelectedButton: true,
        hideSearchBox: false,
        positionAbsolute: true,
        rows: [],
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "tag_name",
        rowIdentityPrefixForJAWS: "Tag Name",
        cssClasses_Grid: "tag-cssClasses_Grid",
        cssClasses_Cell: "tag-cssClasses_Cell",
        columns: [
            { fieldName: 'tag_name', display: 'Tag Name', width: '25%' },
            { fieldName: 'tag_description', display: 'Tag Description', width: '25%' },
            { fieldName: 'tag_category_name', display: 'Tag Category', width: '25%' },
            { fieldName: 'start_date', display: 'Start Date', width: '10%', procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) } },
            { fieldName: 'end_date', display: 'End Date', width: '10%', procDataFn: (val) => { return this.cpdFormatters.formatDateString(val) } },
            { fieldName: 'active_ind', display: 'Active', width: '5%', procDataFn: (aVal) => { return aVal ? 'Y' : 'N' } }
        ]
    };



    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        domSanitizer: DomSanitizer,
        helpers: Helpers,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        this._disableControls = false;

        //Prep the validation object
        this.casValidate = new CASValidate();

    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        // Growl Prep
        //--------------------
        this.initalizeGrowlBox();

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        // Load the form fields
        //-----------------------------------
        this.casNavBoxService.ActionsLoading = true;
        this.loadActionLinks();

        this.markTagManagementGridAsLoading(true);

        this.loadCategories(() => {
            this.initTagManagementGrid(() => {
                this.ngOnInit_Complete();
            });
        });

    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {

        //Init the validation class
        this.casValidate.initialize(true);

        this._pageLoading = false;
    };

    //========================================
    // initalizeGrowlBox
    //========================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    }

    // EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // categoryFilterChanged
    //==================================
    categoryFilterChanged(e) {
        this.initTagManagementGrid();
    };

    gridRefreshClicked() {
        if (this.tagManagementGrid) {
            this.tagManagementGrid.MarkAsLoading(true);
        }
        else {
            this.tagManagementGrid.loading = true;
        }
        this._selectedRow = null;

        // Refresh grid
        this.initTagManagementGrid(() => {
            this.ngOnInit_Complete();
            this.tagManagementGrid.MarkAsLoading(false);
        });
    };

    //==================================
    // _formChanged
    //==================================
    _formChanged(modelName, event) {
        //Mark the form dirty if it isn't already
        if (!this._popupDirty) {
            this._popupDirty = true;
        }

        //Check the popup's validity
        let isValid = this.casValidate.isAllValid(true, modelName);
        if (isValid) {
            this._popupValid = true;
        }
        else {
            //Form is invalid
            this._popupValid = false;
        }
    };

    //==================================
    // gridRowSelected 
    //==================================
    gridRowSelected(row) {
        //This is called when a row is selected AND unselected, resulting in a "null" selected row when unselected
        this._selectedRow = this.tagManagementGrid.GetFirstSelectedRow(); //There will only be one for this single-select grid
    }

    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {
        if (!action || !action.field_name) { return; }

        switch (action.field_name.toLowerCase()) {

            case "act_add_tag":
                this.action_addTag();
                break;
            case "act_edit_tag":

                //Make sure a tag has been selected
                if (!this._selectedRow) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }

                //check if tag is no longer active
                if (this._selectedRow.end_date) {
                    this.growlBox.addGrowl("info", "The selected tag has ended, and cannot be edited.");
                    return;
                }
                this.action_editTag();
                break;
            case "act_end_tag":

                //Make sure a tag has been selected
                if (!this._selectedRow) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }

                //check if tag is no longer active
                if (this._selectedRow.end_date) {
                    this.growlBox.addGrowl("info", "The selected tag has already been ended.");
                    return;
                }
                this.action_endTag();
                break;
            case "act_category_management":
                this.router.navigate(["/cpdes/tagging/categorymanagement"]);
                break;
        }

    };

    //==================================
    //  onGridSearch
    //==================================
    onGridSearch(searchText) {

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0) {
            this.tagManagementGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.tag_name.toLowerCase().indexOf(searchText) >= 0 || row.tag_category_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.tagManagementGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    };


    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // action_addTag
    //=======================================
    action_addTag() {

        //Prep the popup
        this._popupDirty = false;
        this._popupValid = true;
        this._popupMode = "new";

        this._selectedTagId = 0;
        this._popupTagTitle = "Add Tag";
        this._popupTag = {
            tag: {
                tag_id: null,
                tag_name: "",
                tag_description: "",
                start_date: "",
                tag_category: []
            }
        }

        this.popEditTag.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });
    }

    //=======================================
    // action_editTag
    //=======================================
    action_editTag() {

        if (!this._selectedRow) {
            this.growlBox.addGrowl("info", "Please select a row to edit");
            return;
        }

        //Prep the popup
        this._popupDirty = false;
        this._popupValid = true;
        this._popupMode = "edit";

        this._selectedTagId = this._selectedRow.tag_id;
        this._popupTagTitle = "Edit Tag";
        this._popupTag = {
            tag: {
                tag_id: this._selectedRow.tag_id,
                tag_name: this._selectedRow.tag_name,
                tag_description: this._selectedRow.tag_description,
                start_date: this._selectedRow.start_date ? new Date(this._selectedRow.start_date).toISOString().substring(0, 10) : null
            }
        }

        this._selectedPopupCategory = this._popupCategories.find(category => {
            return category.tag_category_id === this._selectedRow.tag_category_id;
        });

        this._tagsInUse = this._tagsInUse.filter(tag => tag !== this._selectedRow.tag_name);

        this.popEditTag.Open(() => {

            //Clear the validation messages
            this.casValidate.markAllValid();
        });

    };

    //=======================================
    // action_endTag
    //=======================================
    action_endTag() {

        this.popEndTag.Open();
    }


    //=======================================
    // initTagManagementGrid
    //======================================
    initTagManagementGrid(fnOnComplete) {
        this.markTagManagementGridAsLoading(true);
        this.loadAllTags((dto) => {
            this._selectedRow = null;
            if (this.tagManagementGrid) {
                this.tagManagementGrid.SetRows(dto);
                console.log("Tag Grid init".format(this._componentName, this._formName));
                this.markTagManagementGridAsLoading(false);
            }
            else {
                this._tagManagementGridSettings.rows = dto;
            }

            if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(); }
        });
    };

    //=======================================
    // loadActionLinks
    //=======================================
    loadActionLinks() {

        //Load the form fields
        let actions = [];
        actions.push(new FormAction("act_add_tag", "Add Tag"));
        actions.push(new FormAction("act_edit_tag", "Edit Tag")); 
        actions.push(new FormAction("act_end_tag", "End Tag")); 
        actions.push(new FormAction("act_category_management", "Category Management"));
        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;

    }

    //=======================================
    // loadAllTags
    //=======================================
    loadAllTags(fnOnComplete, fnOnError) {
        this._tagsInUse = [];
        this.webServices.Get({
            apiPath: "/tagging/getAllTags",
            args: {
                categoryId: this._selectedCategoryFilter.tag_category_id,
                showActive: false
            }
           
        })
            .then(res => {
                console.log("[{0}:/tagging/getAllTags] - res:".format(this._componentName), res);
                this._allTags = res.data.DTO;
                this._allTags.forEach((tag) => this._tagsInUse.push(tag.tag_name));

                if (this.helpers.isFunction(fnOnComplete)) { fnOnComplete(res.data.DTO); }
            })
            .catch(err => {
                console.log(err);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                if (fnOnError) { fnOnError(); }
            });
    };

    //==================================
    // loadCategories
    //==================================
    loadCategories(fnOnSuccess, fnOnError) {

        this.webServices.Get({
            apiPath: "/tagging/getAllTagCategories",
            args: { showActive: true }
        })
            .then(res => {
                console.log("[{0}:/tagging/getAllTagCategories] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                try {

                    //Build the category lists
                    this._popupCategories = [{ tag_category_name: "", tag_category_id: -1 }].concat(dto);
                    this._selectedPopupCategory = this._popupCategories[0];
                    this._categoryFilters = [{ tag_category_name: "All", tag_category_id: "" }].concat(dto);
                    this._selectedCategoryFilter = this._categoryFilters[0];
                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:loadCategories()]".format(this._componentName), err);
                    if (fnOnError) { fnOnError(); }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

                if (fnOnError) { fnOnError(); }
            });
    };

    //=======================================
    // markTagManagementGridAsLoading
    //=======================================
    markTagManagementGridAsLoading(isLoading) {

        if (this.tagManagementGrid) {
            this.tagManagementGrid.MarkAsLoading(isLoading);
        }
        else {
            this._tagManagementGridSettings.loading = isLoading;
        }
    };

    //==================================
    // prepTagForSave
    //==================================
    prepTagForSave() {
        //Copy tag
        let tag = Object.assign({}, this._popupTag.tag);

        tag.tag_name = this._popupTag.tag.tag_name;
        tag.tag_description = this._popupTag.tag.tag_description;
        tag.tag_category_id = this._selectedPopupCategory.tag_category_id;

        //Convert NgbDateStruct fields to date fields
        tag.start_date = this._popupTag.tag.start_date ? new Date(this._popupTag.tag.start_date).toISOString() : null;

        return tag;
    };

    //==================================
    // saveTag
    //==================================
    saveTag() {

        //Validaton
        if (this._tagsInUse.includes(this._popupTag.tag.tag_name)) {
            this.growlBox.addGrowl("error", "Tag name already in use.");
            return;
        }

        let isValid = this.casValidate.isAllValid(true, "popupEditTagFields");

        if (!this._popupDirty) {
            alert("No changes detected.");
            return;
        }

        if (!isValid) {
            alert("Please ensure that all field are valid and complete.");
            return;

        }

        this.popEditTag.Close();
        this.markTagManagementGridAsLoading(true);

        if (this._popupMode == "new") {
            this.insertTag();
        }
        if (this._popupMode == "edit") {
            this.updateTag();
        }

    }

    //==================================
    // endtag
    //==================================
    endTag() {
        this.growlBox.addGrowl("info", "Ending tag...");
        console.log(`Ending tag: `);
        this.webServices.Post("/tagging/endTag", this._selectedRow.tag_id)
            .then((res) => {
                if (res.Success) {

                    //Update the alerts
                    this.growlBox.addGrowl("success", "End complete");

                    //Do a full refresh of tags
                    this.loadCategories(() => {
                        this.initTagManagementGrid(() => {
                            this.markTagManagementGridAsLoading(false);
                        });
                    });
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-TBL-ET1":
                            this.growlBox.addGrowl("error", "Please end tag associations to all targets prior to ending tag.");
                            break;
                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                    this.markTagManagementGridAsLoading(false);
                }

            })

            .catch((err) => {
                this.casNavBoxService.EnableAllLinks();
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markTagManagementGridAsLoading(false);
            });
    }

    //==================================
    // insertTag
    //==================================
    insertTag() {

        let tagForSave = this.prepTagForSave();
        console.log(`Saving tag: `, tagForSave);
        this.webServices.Post("/tagging/addTag", tagForSave)
            .then((res) => {
                if (res.Success) {

                    //Update the alerts
                    this.growlBox.addGrowl("success", "Save complete");

                    //Do a full refresh of tags
                    this.loadCategories(() => {
                        this.initTagManagementGrid(() => {
                            this.markTagManagementGridAsLoading(false);
                        });
                    });
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-TBL-AT1":
                            this.growlBox.addGrowl("error", "Tag parameter empty.");
                            break;
                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                    this.markTagManagementGridAsLoading(false);
                }

            })

            .catch((err) => {
                this.casNavBoxService.EnableAllLinks();
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markTagManagementGridAsLoading(false);
            });

    }

    //==================================
    // updatetag
    //==================================
    updateTag() {
        this.growlBox.addGrowl("info", "Updating tag...");
        let tagForSave = this.prepTagForSave();
        console.log(`Updating tag: `, tagForSave);
        this.webServices.Post("/tagging/updateTag", tagForSave)
            .then((res) => {
                if (res.Success) {

                    //Update the alerts
                    this.growlBox.addGrowl("success", "Save complete");

                    //Do a full refresh of tags
                    this.loadCategories(() => {
                        this.initTagManagementGrid(() => {
                            this.markTagManagementGridAsLoading(false);
                        });
                    });
                }
                else {
                        switch (res.ErrorCode) {

                            case "ERR-TBL-UT1":
                                this.growlBox.addGrowl("error", "Tag parameter empty.");
                                break;
                            default:
                                this.growlBox.addGrowl("error", res.ErrorMessage);
                        }
                        this.markTagManagementGridAsLoading(false);
                    }

                })

            .catch((err) => {
                this.casNavBoxService.EnableAllLinks();
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                this.markTagManagementGridAsLoading(false);
            });
    }


    //==================================
    // sortTagData
    //==================================
    sortTagData(arr) {
        arr.sort((row1, row2) => {
            return row1.tag_name < row2.tag_name ? -1 : (row1.tag_name > row2.tag_name ? 1 : 0);
        });
    };


};